export default __webpack_public_path__ + "static/media/scholar_4.652373c9.jpg";